import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { RoomPastInMs } from "@youm-front/room/domain";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomsListRequestDTO,
  RoomsListResponseDTO,
  RoomsListResponseRaw
} from "../dto";

@Injectable()
export class RoomsPastListService {
  constructor(private readonly apiService: ApiService) {}

  roomsPastList(
    _roomsListRequestDTO: RoomsListRequestDTO
  ): Observable<RoomsListResponseDTO> {
    const params = new URLSearchParams();
    const roomStartAtUpperBoundMs = Date.now() - RoomPastInMs;

    params.set("roomStartAtUpperBound", roomStartAtUpperBoundMs + "");

    return this.apiService
      .get<RoomsListResponseRaw>(`rooms?${params}`)
      .pipe(map((_) => new RoomsListResponseDTO({ rooms: _.rooms })));
  }
}
